import type { AuthenticatedUserPayload } from '@Application/Security/Authentications/Actions/userAuthenticated';

export type SecondFactorEnrolledPayload = {
	readonly user: AuthenticatedUserPayload;
	readonly recoveryCodes: readonly string[];
};

export type SecondFactorEnrolledAction = {
	type: 'SECOND_FACTOR_ENROLLED';
	payload: SecondFactorEnrolledPayload;
};

export default (payload: SecondFactorEnrolledPayload): SecondFactorEnrolledAction => ({
	type: 'SECOND_FACTOR_ENROLLED',
	payload,
});
